import script from "./AddMetting.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMetting.vue?vue&type=script&setup=true&lang=js"

import "./AddMetting.vue?vue&type=style&index=0&id=4ebe206c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ebe206c"]])

export default __exports__